import { render, staticRenderFns } from "./Invest.vue?vue&type=template&id=2849a841&scoped=true&"
import script from "./Invest.vue?vue&type=script&lang=js&"
export * from "./Invest.vue?vue&type=script&lang=js&"
import style0 from "./Invest.vue?vue&type=style&index=0&id=2849a841&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849a841",
  null
  
)

export default component.exports